@if (isLoading) {
  <div class="api-state-wrapper api-state-wrapper--loading">
    <div class="api-state-wrapper__center">
      <app-spinner [size]="'large'" [variant]="'primary'"></app-spinner>
    </div>
  </div>
} @else if (isError) {
  <div class="api-state-wrapper api-state-wrapper--error">
    <div class="api-state-wrapper__center">
      <div class="api-state-wrapper__error-content">
        <div class="api-state-wrapper__error-icon">
          <i class="fas fa-exclamation-triangle"></i>
        </div>
        <h4 class="api-state-wrapper__error-title">{{ errorMessage }}</h4>
        <p class="api-state-wrapper__error-description">{{ errorDetails }}</p>
        <div class="api-state-wrapper__error-actions">
          <button type="button" class="api-state-wrapper__btn api-state-wrapper__btn--primary" (click)="onRetry()">
            {{ retryLabel }}
          </button>
          <button type="button" class="api-state-wrapper__btn api-state-wrapper__btn--secondary" (click)="onRefreshPage()">
            {{ refreshLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
} @else {
  <ng-content></ng-content>
}
